import { dcpcApi } from './dcpcApi';

export const CHANNEL_PARAMS_TAG = 'ChannelParamsTag';
export const CHANNEL_PARAMS_MUTATION_TAG = 'ChannelParamsMutationTag';

dcpcApi.enhanceEndpoints({ addTagTypes: [CHANNEL_PARAMS_TAG, CHANNEL_PARAMS_MUTATION_TAG] });

const channelParamApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    updateChannelParam: builder.mutation({
      query: (body) => ({
        url: `channel-params${body.id ? `/${body.id}` : ''}`,
        method: body.id ? 'PUT' : 'POST',
        body,
      }),
      invalidatesTags: (result, _, body) => {
        if (result) {
          return [{ type: CHANNEL_PARAMS_MUTATION_TAG, id: body.id || result.channelTypeParamId }];
        }
        return [CHANNEL_PARAMS_MUTATION_TAG];
      },
    }),
    deleteChannelParamById: builder.mutation({
      query: (id) => ({
        url: `channel-params${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [CHANNEL_PARAMS_MUTATION_TAG],
    }),
  }),
});

export const {
  useUpdateChannelParamMutation,
} = channelParamApi;
